import {Component, Host, h, Prop, Listen, Element, Event, EventEmitter, State} from '@stencil/core';
import {ListKeyManager} from "../../utils/listkeymanager";
import {NestSelectMode, NestSelectOption} from "./nest-select.interfaces";

@Component({
  tag: 'nest-select',
  styleUrl: 'nest-select.scss',
  shadow: true,
})
export class NestSelect {
  nativeInput?: HTMLInputElement;
  private keyManager: ListKeyManager<NestSelectOption>;

  private selectId = `nest-input-${selectId++}`

  @State() filteredItems: NestSelectOption[] = []

  @Element() el: HTMLElement;

  @Prop() items?: string | Array<NestSelectOption>;

  @Prop({mutable: true}) value: string | number = null;

  @Prop() label: string | null;

  @Prop() placeholder: string = 'Select option...'

  @Prop({mutable: true})  showMenu: boolean = false;

  @Prop() mode: NestSelectMode = 'single';

  @Prop({ reflect: true }) public clearable: boolean = true;

  @Event() nestChange!: EventEmitter<any | null>;

  @Listen('click', {target: 'window'})
  clickOutside(event): void {
    if (!this.el.contains(event.target)) {
      this.hide();
    }
  }

  toggle = (): void => {
    this.showMenu = !this.showMenu;
  }

  selectAnswer = (value) => {
    this.value = value;
    this.nestChange.emit(this.value);
    this.hide();
  }

  clearInput = () => {
    this.value = null;
    this.hide();
    this.nestChange.emit(null)
  }

  public componentWillLoad(): void {
    this.keyManager = new ListKeyManager<NestSelectOption>([]);
  }

  @Listen('keydown')
  handleKeyDown(event: KeyboardEvent){
    const {key} = event;
    this.keyManager.handleKeyDown(event);

    switch (key) {
      case "Tab": console.log('Tab'); break;
      case "Escape": this.hide(); break;
      case "ArrowDown": console.log('ESC') ; break;
    }
  }

  private get prepareItems(): NestSelectOption[] {
    const items = typeof this.items === 'string' ? JSON.parse(this.items) : this.items;
    if(items.every(item => typeof item !== 'object')) {
      return items.map(item => ({
        label: item,
        value: item
      }))
    } else return items;
  }

  private hide(): void {
    if (!this.showMenu) return;
    this.showMenu = false;
  }

  onInput = (event: InputEvent) => {
    const input = this.getInputTarget(event);
    this.value = input.value;
  }

  private getInputTarget(ev: Event): HTMLInputElement | null {
    return ev.target as HTMLInputElement | null
  }

  render() {
    return (
      <Host>
        <div class="nest-select">
          {this.label &&
            <div class='nest-select__label'>{this.label}</div>
          }
          <div class="nest-select__control">
            <input
              id={this.selectId}
              ref={inputEl => (this.nativeInput = inputEl)}
              onInput={this.onInput}
              value={this.value}
              placeholder={this.placeholder}
              onFocus={() => this.showMenu = true}
              class="p-1 px-2 bg-background appearance-none outline-none w-full"
            />
            {(this.clearable && this.value) && (
              <div>
                <button
                  class="cursor-pointer w-6 h-full flex items-center outline-none focus:outline-none"
                  onClick={this.clearInput}
                >
                  <nest-icon name='close-circle'></nest-icon>
                </button>
              </div>
            )}
            <div
              class="text-gray-300 w-8 py-1 pl-3 pr-1 border-l border-input flex items-center"
              onClick={this.toggle}>
              <button class={{
                "cursor-pointer w-6 h-6 text-gray-600 outline-none focus:outline-none transition-all": true,
                "-rotate-180": this.showMenu === true
              }}>
                <nest-icon name='chevron-down'></nest-icon>
              </button>
            </div>
          </div>

          {this.showMenu && (
            <div class="absolute shadow top-100 z-40 w-full lef-0 pb-1 rounded border border-input max-h-select overflow-y-auto">
              {this.prepareItems?.map((option: any) => (
                <nest-select-option
                  label={option.label || option}
                  selected={this.value === (option.value || option)}
                  onClick={() => this.selectAnswer(option?.value || option)}
                ></nest-select-option>
              ))}
            </div>
          )}
        </div>
      </Host>
    );
  }
}

let selectId = 0;
